/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

/**
 * Sleep for a number of milliseconds
 * @param {number} duration 
 * @returns 
 */
export function sleep (duration) {
    return new Promise((resolve) => setTimeout(resolve, duration));
}
